export default "__VITE_ASSET__CvNsDLCa__"